import type { SVGProps } from 'react'
import * as React from 'react'

const smallScreenInfoImage = (props: SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
  <svg width={64} height={64} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={32} cy={32} r={32} fill="url(#paint0_linear_503_147)" />
    <path
      d="M21.3334 20.0021H42.6667C44.1395 20.0021 45.3334 21.196 45.3334 22.6687V36.0021C45.3334 37.4748 44.1395 38.6687 42.6667 38.6687H21.3334C19.8606 38.6687 18.6667 37.4748 18.6667 36.0021V22.6687C18.6667 21.196 19.8606 20.0021 21.3334 20.0021Z"
      stroke="white"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M37.3334 44.0017H26.6667" stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M32 38.6682V44.0015" stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
    <defs>
      <linearGradient id="paint0_linear_503_147" x1={32} y1={0} x2={32} y2={64} gradientUnits="userSpaceOnUse">
        <stop stopColor="#69E0AE" />
        <stop offset={1} stopColor="#2ACC88" />
      </linearGradient>
    </defs>
  </svg>
)

export default smallScreenInfoImage
